
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/shared/open-map.kpa`,
      template: `<div class="open-map">
        <div id="map" class="box-shadow"></div>
    </div>`,
      style: `open-map .open-map {
  padding-top: 64px;
  background-color: #f2f2f1;
}
open-map .open-map #map {
  position: relative;
  left: -32px;
  width: calc(100% + 64px);
  height: 500px;
  z-index: 1;
}
@media (min-width: 760px) {
  open-map .open-map #map {
    position: relative;
    left: 0;
    width: 100%;
    height: 500px;
    border-radius: 8px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        zoom: 18,
        minZoom: 1,
        maxZoom: 18,
        position: [50.933115, 6.946549],
        popup: '<b>FASE2</b><br>Reinoldstr. 6b, 50676 Köln',
    },
    methods: {
        initMap() {
            this.map = L.map('map', {
                center: this.position,
                zoom: this.zoom,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom,
                zoomControl: true,
                attributionControl: true,
                scrollWheelZoom: false,
                doubleClickZoom: false,
                dragging: true,
                keyboard: true,
                tap: true,
                preferCanvas: false,
                inertia: true,
                worldCopyJump: false,
            });
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                minZoom: this.minZoom,
                maxZoom: this.maxZoom,
                attribution: '© OpenStreetMap contributors',
            }).addTo(this.map);
            ;
            var marker = L.marker(this.position).addTo(this.map);
            marker.bindPopup(this.popup).openPopup();
        }
    },
    mounted() {
        const leafletCss = document.createElement('link');
        leafletCss.rel = 'stylesheet';
        leafletCss.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        leafletCss.id = 'leaflet-css';
        const leafletJs = document.createElement('script');
        leafletJs.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        leafletJs.async = true;
        leafletJs.id = 'leaflet-js';
        document.head.appendChild(leafletCss);
        document.head.appendChild(leafletJs);
        leafletJs.onload = () => {
            console.log('Leaflet.js geladen und bereit zur Verwendung.');
            this.initMap();
        };
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
        const leafletCss = document.getElementById('leaflet-css');
        const leafletJs = document.getElementById('leaflet-js');
        if (leafletCss) {
            document.head.removeChild(leafletCss);
        }
        if (leafletJs) {
            document.head.removeChild(leafletJs);
        }
        console.log('Leaflet-Ressourcen entfernt und Karte zerstört.');
    }
};
 })()`
    };
  